import { render, staticRenderFns } from "./Deboras.vue?vue&type=template&id=ccaf860c&scoped=true"
import script from "./Deboras.vue?vue&type=script&lang=js"
export * from "./Deboras.vue?vue&type=script&lang=js"
import style0 from "./Deboras.vue?vue&type=style&index=0&id=ccaf860c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf860c",
  null
  
)

export default component.exports